import { render, staticRenderFns } from "./ReporteSGMM.vue?vue&type=template&id=07622892"
import script from "./ReporteSGMM.vue?vue&type=script&lang=js"
export * from "./ReporteSGMM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports